import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 22H4C2.89543 22 2 21.1046 2 20V9.049C2.03375 8.37786 2.39728 7.76686 2.971 7.41699L10.971 2.61699C11.6041 2.23737 12.3949 2.23737 13.028 2.61699L21.028 7.41699C21.6292 7.77977 21.9976 8.42984 22 9.13199V20C22 21.1046 21.1046 22 20 22ZM4 9.86799V20H20V9.86799L12 15.201L4 9.86799ZM12 4.33199L5.316 8.34199L12 12.798L18.683 8.34199L12 4.33199Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MailOpen"
);
